<template>
  <div class="pt-5 md:p-5">
    <p class="mb-4">{{ $t('log_in_create_account_title') }}</p>
    <register-consent-checkboxes v-model:isTermsAccepted="isTermsAccepted" v-model:isMarketingAllowed="isMarketingAllowed" />
  </div>
</template>

<script setup lang="ts">
import RegisterConsentCheckboxes from '@/components/login/register-consent-checkboxes.vue'

import { useAuthStore } from '@/store/auth'
import { useSocialLogin } from '@/composables/useSocialLogin'
import type { SocialLoginType } from '@/types/socialLogin'

const authStore = useAuthStore()
const { registerWith } = useSocialLogin()

const isTermsAccepted = ref(true)
const isMarketingAllowed = ref(true)
const isLoading = ref(false)

const pendingAuth = computed(() => authStore.pendingThirdPartyAuth)
const loginType = computed(() => pendingAuth.value?.type as SocialLoginType | undefined)

const isSubmitDisabled = computed(() => !isTermsAccepted.value || !isMarketingAllowed.value)

const handleSubmit = async () => {
  if (isSubmitDisabled.value || !loginType.value || !pendingAuth.value) return

  try {
    isLoading.value = true

    await registerWith(
      loginType.value,
      {
        token: pendingAuth.value.accessToken,
        authorizationCode: pendingAuth.value.authorizationCode,
        name: pendingAuth.value.name,
        redirectUrl: pendingAuth.value.redirectUrl,
        fallbackUrl: pendingAuth.value.fallbackUrl || '/',
      },
      {
        userContract: {
          isTermsAccepted: isTermsAccepted.value,
          isMarketingAllowed: isMarketingAllowed.value,
        },
      }
    )
  } finally {
    isLoading.value = false
  }
}

defineExpose({
  isLoading,
  isSubmitDisabled,
  handleSubmit,
})
</script>
